import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './recent.css';

export default function Recent(props) {
  const [posts, setPosts] = useState([]);
  const collection = props.collect;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/${collection}`)
      .then((response) => response.json())
      .then((data) => {
        const sortedPosts = data
          .filter(post => post.createdAt) 
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); 
        setPosts(sortedPosts.slice(0, 10)); 
      })
      .catch((error) => console.error('Error fetching posts:', error));
  }, [collection]);

  const navigate = useNavigate();

  const handlePostsClick = (id) => {
    navigate(`/news/${id}/${collection}`);
  };

  const main = { entertainments: 'Entertainment',
    movies: 'Movies',
    sports: 'Sports',
    indianhistory:'Indian History',
    untoldhistory:'Untold History',
    mysteries:'Mysteries',
    india:'India',
    world:'World',
    tech:'Tech',
    lifestyle:'Life Style',
    health:'Health & Wealth'
  };

  return (
    <>
      <section id='recent-section'>
        <div id='recent-cont'>
          <h1>Recent Posts On {main[collection]}</h1>
          <div id='recentarticle'>
            {posts.length > 0 ? (
              posts.map((post, index) => (
                <div key={index} onClick={() => handlePostsClick(post._id)}>
                  {post.thumbnail ? (
                    <>
                      <img src={`data:image/jpeg;base64,${post.thumbnail}`} alt={post.title} />
                    </>
                  ) : (
                    <p>No Thumbnail Available</p>
                  )}
                  <h2>{post.title}</h2>
                  <p>{new Date(post.createdAt).toLocaleDateString()}</p>
                </div>
              ))
            ) : (
              <p>Loading posts...</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
